// extracted by mini-css-extract-plugin
export default {"ButtonGroup":"kIZxsDNIFdGZhWX_e59Z","Button":"NmkAv1nvOCWprhxjsHj8","whatsapp_icon":"TW3JZXyveZ54oemDMdse","call_icon":"zO1OUIVeOkiOOlgdUfFc","ButtonText":"OxZ0LjmkBkp0n2KWWxOs"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"ButtonGroup\":\"kIZxsDNIFdGZhWX_e59Z\",\"Button\":\"NmkAv1nvOCWprhxjsHj8\",\"whatsapp_icon\":\"TW3JZXyveZ54oemDMdse\",\"call_icon\":\"zO1OUIVeOkiOOlgdUfFc\",\"ButtonText\":\"OxZ0LjmkBkp0n2KWWxOs\"}";
        // 1775474909784
        var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  